class Permission<PermissionAction> {
  public readonly action: PermissionAction;
  public readonly permission: boolean;
  constructor({ action, permission }: { action: PermissionAction; permission: boolean }) {
    this.action = action;
    this.permission = permission;
  }

  public static fromJSON<PermissionAction>(value: any, availableActions: string[]) {
    const { action, permission } = Object.assign({}, value);

    if (typeof permission !== 'boolean') throw new TypeError('.permission must be a boolean');
    if (action && !availableActions.includes(action)) throw new TypeError('.action must be a valid action string');

    return new Permission<PermissionAction>({
      action: action as PermissionAction,
      permission,
    });
  }
}

export default Permission;
